<div *ngIf="!createMode && outDatedSeasons" class="alert alert-warning">
  <span class="icol-error" title="{{ 'OUTDATED_SEASON' | translate }}"></span>
  {{ 'OUTDATED_SEASON' | translate }}
</div>

<form [formGroup]="form" class="form-horizontal" autocomplete="off" novalidate>
  <app-translation-options
    [defaultLanguage]="defaultLanguage"
    [additionalLanguages]="additionalLanguages"
    (openedTranslation)="onOpenedTranslation($event)"
    *ngIf="!createMode && additionalLanguages.length > 0"
  ></app-translation-options>

  <!-- Name -->
  <div class="form-group">
    <label class="col-md-4 control-label">
      <span class="required" [hidden]="viewMode">*</span> {{ 'NAME' | translate }}
    </label>
    <div class="col-md-8">
      <div [hidden]="!viewMode" class="form-label">
        {{ season.name }}
      </div>
      <div [hidden]="viewMode">
        <input type="text" class="form-control" formControlName="name" maxlength="100" />
        <app-form-errors
          [control]="form.controls['name']"
          [formSubmited]="formSubmited"
        ></app-form-errors>
        <app-form-server-errors [error]="serverErrors['name']"></app-form-server-errors>
      </div>
    </div>
  </div>

  <!-- From -->
  <div class="form-group">
    <label class="col-md-4 control-label">
      <span class="required" [hidden]="viewMode">*</span> {{ 'INITIAL_DATE' | translate }}
    </label>
    <div class="col-md-8">
      <div [hidden]="!viewMode" class="form-label">
        {{ season.from | dateFormat: dateDisplay }}
      </div>
      <div [hidden]="viewMode">
        <input
          type="text"
          class="form-control calendar_input"
          ngxDaterangepickerMd
          formControlName="from"
          [locale]="calendarLocale"
          [singleDatePicker]="true"
          [alwaysShowCalendars]="true"
          [showDropdowns]="true"
          [autoApply]="true"
          maxlength="23"
        />
      </div>
    </div>
  </div>

  <!-- To -->
  <div class="form-group">
    <label class="col-md-4 control-label">
      <span class="required" [hidden]="viewMode">*</span> {{ 'FINAL_DATE' | translate }}
    </label>
    <div class="col-md-8">
      <div [hidden]="!viewMode" class="form-label">
        {{ season.to | dateFormat: dateDisplay }}
      </div>
      <div [hidden]="viewMode">
        <input
          type="text"
          class="form-control calendar_input"
          ngxDaterangepickerMd
          formControlName="to"
          [locale]="calendarLocale"
          [singleDatePicker]="true"
          [alwaysShowCalendars]="true"
          [showDropdowns]="true"
          [autoApply]="true"
          maxlength="23"
        />
      </div>
    </div>
  </div>

  <div class="form-actions no-wrap">
    <app-item-detail-form-actions
      [createMode]="createMode"
      [disableSaveItem]="sendingForm"
      [isModal]="isModal"
      [sendingForm]="sendingForm"
      [viewMode]="viewMode"
      (canceled)="onCanceled()"
      (edited)="onEditedSeason()"
      (saved)="onSavedSeason()"
    >
    </app-item-detail-form-actions>
  </div>
</form>
